// extracted by mini-css-extract-plugin
export default {"container":"TextTab_container__i0n2x","paper":"TextTab_paper__GDtqJ","sectionTitle":"TextTab_sectionTitle__05F5l","textField":"TextTab_textField__CWd-2"};